<template>
  <div class="box-footer" style="display: block">
    <form @submit.prevent="createComment(postId)">
      <img
        class="img-responsive img-circle img-sm"
        :src="getAvatar()"
        alt="Alt Text"
      />
      <div class="img-push">
        <input
          type="text"
          class="form-control input-sm"
          placeholder="Press enter to post comment"
          v-model="comment"
        />
      </div>
    </form>
  </div>
</template>
<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
export default {
  props: {
    postId: {
      type: String,
      required: true,
    },
    author: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const store = useStore();
    const comment = ref('');
    function createComment(postId) {
      store.dispatch('comment/createComment', {
        postId,
        comment: comment.value,
      });
      comment.value = '';
    }
    function getAvatar() {
      const avatar = store.getters['profile/getAvatar'];
      if (avatar) {
        return `http://localhost:9000/story/${avatar}`;
      }
      return '/img/Friends/guy-3.jpg';
    }
    return {
      comment,
      getAvatar,
      createComment,
    };
  },
}
</script>